module.exports = __webpack_public_path__ + "img/delivery.db8057ce.jpg";